<template>
  <div>
    <BulkInventoryItemViewModal />
    <ResolveMissingInventoryItemModal />
    <ModelLinkSummaryModal />
  </div>
</template>
<script>
import BulkInventoryItemViewModal from "@/components/widgets/Modals/BulkInventoryItemViewModal";
import ResolveMissingInventoryItemModal from "@/components/widgets/Modals/ResolveMissingInventoryItemModal";
import ModelLinkSummaryModal from "@/components/widgets/Modals/ModelLinkSummaryModal";

export default {
  name: "InventoryActions",
  components: {
    BulkInventoryItemViewModal,
    ResolveMissingInventoryItemModal,
    ModelLinkSummaryModal
  }
};
</script>